import { render, staticRenderFns } from "./StudioHomeTemplateCards.vue?vue&type=template&id=1dd8fb28&scoped=true&"
import script from "./StudioHomeTemplateCards.vue?vue&type=script&lang=js&"
export * from "./StudioHomeTemplateCards.vue?vue&type=script&lang=js&"
import style0 from "./StudioHomeTemplateCards.vue?vue&type=style&index=0&id=1dd8fb28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd8fb28",
  null
  
)

export default component.exports